import { render } from "./file-viewer.vue?vue&type=template&id=3ad87e65"
import script from "./file-viewer.vue?vue&type=script&lang=js"
export * from "./file-viewer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__